import React from 'react';

import { Container } from './styles';

const ContainerBox = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ContainerBox;
